export * from "./types.js";
export * from "./copy.js";
export {
  calculateTransferDuty,
  calculateFirstHomeDuty,
  generalDuty,
  assertNoCreditHandoff,
  CreditHandoffError,
} from "./calculate.js";
export { nsw2025_26 } from "./nsw-2025-26.js";
export { vic2025_26 } from "./vic-2025-26.js";
export { qld2025_26 } from "./qld-2025-26.js";

import type { StampDutyRuleSet, StampDutyState } from "./types.js";
import { nsw2025_26 } from "./nsw-2025-26.js";
import { vic2025_26 } from "./vic-2025-26.js";
import { qld2025_26 } from "./qld-2025-26.js";

/**
 * Registry of transfer-duty rulesets keyed by `<state>:<period>`. State tables
 * reprice on independent state-budget schedules; historical periods stay
 * registered so a backdated assessment resolves against the schedule in force
 * on the contract date (never mutate a shipped table — append a new dated one).
 */
export const STAMP_DUTY_RULESETS: Record<string, StampDutyRuleSet> = {
  "NSW:2025-26": nsw2025_26,
  "VIC:2025-26": vic2025_26,
  "QLD:2025-26": qld2025_26,
};

/** The current-period ruleset per state. */
const CURRENT_BY_STATE: Record<StampDutyState, StampDutyRuleSet> = {
  NSW: nsw2025_26,
  VIC: vic2025_26,
  QLD: qld2025_26,
};

/** Resolve the current-period transfer-duty ruleset for a state, or throw. */
export function stampDutyRulesFor(state: StampDutyState): StampDutyRuleSet {
  const rules = CURRENT_BY_STATE[state];
  if (!rules) throw new Error(`no transfer-duty ruleset registered for ${state}`);
  return rules;
}

/** Most recent period shipped — the default for live "this year" calcs. */
export const STAMP_DUTY_CURRENT_PERIOD = "2025-26";
